import api from './apiInstance';

export interface TranscriptionItem {
  id: string;
  roomDbId: number;
  roomId: string;
  companyId: number;
  fromLanguage: string;
  text: string;
  confidence?: number | null;
  messageId?: number | null;
  speakerClientId?: string | null;
  occurredAt: string;
  createdAt: string;
  room?: {
    name?: string;
    roomId?: string;
  };
}

export interface TranscriptionListResponse {
  items: TranscriptionItem[];
  total: number;
  pages: number;
  currentPage: number;
}

export async function getTranscriptions(params: {
  page?: number;
  limit?: number;
  roomId?: string;
  startDate?: string;
  endDate?: string;
  q?: string;
}): Promise<TranscriptionListResponse> {
  const response = await api.get('/transcriptions', { params });
  return response.data.data;
}

